 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"sf-cart~sf-category-page~sf-checkout~sf-cms-page~sf-create-account~sf-forgot-password~sf-login~sf-ou~54acb060":"sf-cart~sf-category-page~sf-checkout~sf-cms-page~sf-create-account~sf-forgot-password~sf-login~sf-ou~54acb060","sf-cart":"sf-cart","sf-category-page~sf-our-shop":"sf-category-page~sf-our-shop","sf-category-page":"sf-category-page","sf-our-shop":"sf-our-shop","sf-checkout":"sf-checkout","sf-cms-page":"sf-cms-page","sf-create-account":"sf-create-account","sf-forgot-password":"sf-forgot-password","sf-login":"sf-login","sf-page-not-found":"sf-page-not-found","sf-payment-cancel":"sf-payment-cancel","sf-payment-success":"sf-payment-success","sf-product":"sf-product","sf-home":"sf-home"}[chunkId]||chunkId) + "-legacy." + {"chunk-2d0e4494":"e31b5c7b","chunk-0a1d1340":"0621266c","sf-cart~sf-category-page~sf-checkout~sf-cms-page~sf-create-account~sf-forgot-password~sf-login~sf-ou~54acb060":"6f292687","sf-cart":"b37f752b","sf-category-page~sf-our-shop":"557881c2","sf-category-page":"b01346f0","sf-our-shop":"dc8fd6f5","sf-checkout":"f69568d1","sf-cms-page":"2697b803","sf-create-account":"0396b1a4","sf-forgot-password":"6a489daa","sf-login":"e815f423","sf-page-not-found":"fce65156","sf-payment-cancel":"fb02e057","sf-payment-success":"1026b220","sf-product":"362d54fd","chunk-330726ee":"06ac0f25","chunk-981b2b7c":"2b3d4635","sf-home":"0f4dec42","chunk-2d0ae5a4":"0b2fc454","chunk-2d0a30fc":"7697b710","chunk-1dad08ae":"176dbe98","chunk-2d0dd83c":"71f0fbf0","chunk-29c8d941":"8fe344ed","chunk-2d0b9c15":"2fd64bbb","chunk-2d0cef33":"a2f3da1d","chunk-1e8f1bb4":"32fd1c04","chunk-593186b8":"a8692f0f","chunk-2d230500":"7fa9de5c","chunk-366982a8":"a6c0cc47","chunk-6dfdf659":"6b827dbe","chunk-710cc131":"b4fa4240"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"sf-our-shop":1,"chunk-330726ee":1,"chunk-981b2b7c":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"sf-cart~sf-category-page~sf-checkout~sf-cms-page~sf-create-account~sf-forgot-password~sf-login~sf-ou~54acb060":"sf-cart~sf-category-page~sf-checkout~sf-cms-page~sf-create-account~sf-forgot-password~sf-login~sf-ou~54acb060","sf-cart":"sf-cart","sf-category-page~sf-our-shop":"sf-category-page~sf-our-shop","sf-category-page":"sf-category-page","sf-our-shop":"sf-our-shop","sf-checkout":"sf-checkout","sf-cms-page":"sf-cms-page","sf-create-account":"sf-create-account","sf-forgot-password":"sf-forgot-password","sf-login":"sf-login","sf-page-not-found":"sf-page-not-found","sf-payment-cancel":"sf-payment-cancel","sf-payment-success":"sf-payment-success","sf-product":"sf-product","sf-home":"sf-home"}[chunkId]||chunkId) + "." + {"chunk-2d0e4494":"31d6cfe0","chunk-0a1d1340":"31d6cfe0","sf-cart~sf-category-page~sf-checkout~sf-cms-page~sf-create-account~sf-forgot-password~sf-login~sf-ou~54acb060":"31d6cfe0","sf-cart":"31d6cfe0","sf-category-page~sf-our-shop":"31d6cfe0","sf-category-page":"31d6cfe0","sf-our-shop":"95b65015","sf-checkout":"31d6cfe0","sf-cms-page":"31d6cfe0","sf-create-account":"31d6cfe0","sf-forgot-password":"31d6cfe0","sf-login":"31d6cfe0","sf-page-not-found":"31d6cfe0","sf-payment-cancel":"31d6cfe0","sf-payment-success":"31d6cfe0","sf-product":"31d6cfe0","chunk-330726ee":"96c7bdd2","chunk-981b2b7c":"e696f0ff","sf-home":"31d6cfe0","chunk-2d0ae5a4":"31d6cfe0","chunk-2d0a30fc":"31d6cfe0","chunk-1dad08ae":"31d6cfe0","chunk-2d0dd83c":"31d6cfe0","chunk-29c8d941":"31d6cfe0","chunk-2d0b9c15":"31d6cfe0","chunk-2d0cef33":"31d6cfe0","chunk-1e8f1bb4":"31d6cfe0","chunk-593186b8":"31d6cfe0","chunk-2d230500":"31d6cfe0","chunk-366982a8":"31d6cfe0","chunk-6dfdf659":"31d6cfe0","chunk-710cc131":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
